import * as actionTypes from "../actions/types";

export default (state = { search: "" }, action) => {
  switch (action.type) {
    case actionTypes.SET_BUNDLES:
      return {
        ...state,
        bundles: action.bundles,
        bundlesPrices: action.bundlesPrices,
        error: false
      };
    case actionTypes.SET_BUNDLES_FAILED:
      return {
        ...state,
        error: true
      };
    case actionTypes.BUNDLE_SAVE_FAILED:
      return {
        ...state,
        error: true
      };
    case actionTypes.BUNDLE_SAVED:
      return {
        ...state,
        error: false
      };
    case "@@router/LOCATION_CHANGE":
      return { archived: state.archived, search: state.search };
    case actionTypes.UPDATE_BUNDLES_SEARCH:
      return {
        ...state,
        search: action.payload
      };
    case actionTypes.DELETE_RECORD_SUCCESS:
      if (action.resource === "bundles" && action.apiVersion === "v1") {
        const {
          bundles: { bundles, ...rest1 },
          ...rest
        } = state;

        const { [action.recordSlug]: removedValue, ...rest2 } = bundles;

        const newState = { ...rest, bundles: { bundles: { ...rest2 }, ...rest1 } };

        return newState;
      } else {
        return state;
      }
    default:
      return state;
  }
};
